module.exports = __webpack_public_path__ + "static/media/user.d28f46d3.svg";